export const MINI_DRAWER_WIDTH = 64;
